import { useTheme } from "@mui/material";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";
import { LandingQuote } from "../LandingQuote/LandingQuote";

interface Props {
  body?: any;
  bgStyle?: 'primary' | 'secondary' | null;
  containerProps?: any;
  isCentered?: boolean;
  jobTitle?: string;
  media?: any;
  name?: string;
  title?: string;
  variant?: 'left' | 'right' | null;
}

export function ContentRendererQuote(block: Props) {
  const theme = useTheme();
  const {
    body,
    bgStyle,
    containerProps,
    isCentered,
    jobTitle,
    media,
    name,
    title,
    variant
  } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <LandingQuote
        bgStyle={bgStyle || 'primary'}
        image={media?.data?.attributes?.url}
        isCentered={isCentered}
        jobTitle={jobTitle}
        name={name}
        title={title}
        variant={variant || 'left'}
      >
        <ContentRendererBody
          body={body}
          paragraphVariant="bodyLg"
          paragraphSx={{ color: theme.palette.primary.contrastText, mb: 'auto' }}
        />
      </LandingQuote>
    </ContentRendererContainer>
  )
}
